module.exports = require("rxjs/observable/of");


//////////////////
// WEBPACK FOOTER
// external "rxjs/observable/of"
// module id = 109
// module chunks = 0